(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("embed-pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["embed-pdfjs-dist/build/pdf"] = factory();
	else
		root["embed-pdfjs-dist/build/pdf"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition